import { useState, useCallback } from 'react';
import restApi from '../lib/restApi';

const useApi = (api, params) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const fetch = useCallback(
    fetchParams =>
      restApi(
        api,
        fetchParams || params,
        setData,
        setLoading,
        setError,
        setSuccess
      ),
    [api, params]
  );

  return {
    loading,
    error,
    success,
    data,
    fetch,
  };
};

export default useApi;
